import React from "react";
import "./OurStoryBox.css";
import { useLocation } from "react-router-dom";

export default function OurStoryBox({ Head, Number, Title, Image, ImageAlt }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  return (
    <>
      <div className="OSBoxContainer">
        <div className={`OSBoxP1 TFut24PxPC ${isArabic ? "arabic" : "english"}`}>{Head}</div>
        <div className={`OSBoxP2 TGLo32PxPC ${isArabic ? "arabic" : "english"}`}>
          <div>{Title}</div> <div>{Number}</div>
        </div>
        <div>
          <img src={Image} alt={ImageAlt} className="OSBoxImg" />
        </div>
      </div>
    </>
  );
}
